import { render, staticRenderFns } from "./commentsView.vue?vue&type=template&id=4e94d2c0&"
import script from "./commentsView.vue?vue&type=script&lang=js&"
export * from "./commentsView.vue?vue&type=script&lang=js&"
import style0 from "./commentsView.vue?vue&type=style&index=0&id=4e94d2c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports